import styled from 'styled-components';
import { rem } from 'polished';
var Item = styled.div.withConfig({
  displayName: "Item",
  componentId: "sc-185mzl9-0"
})(["display:", ";margin:0 ", ";"], function (_ref) {
  var isListVertical = _ref.isListVertical;
  return isListVertical ? 'block' : 'inline-block';
}, rem(8));
export default Item;